<script setup lang="ts">
  import { useHttpClient, useRoute } from '@othercommerce/foundation';

  const props = defineProps({
    token: { type: String, required: true },
    email: { type: String, required: false, default: null },
  });

  type ResetData = {
    email: string;
    password: string;
    password_confirmation: string;
  }

  const http = useHttpClient();
  const route = useRoute();

  function onSubmit(data: ResetData) {
    return http.post(route('web.account.password.reset.store'), { token: props.token, ...data });
  }
</script>
<template>
  <main id="main" class="reset">
    <SfTile large>
      <template #title>
        <h1 class="account-heading reset__reset">
          {{ $t('SHOP.AUTH.HEADER.SET_NEW_PASSWORD') }}
        </h1>
      </template>
      <template #default>
        <FormController :onSubmit="onSubmit" :data="{ email }" v-slot="{ processing }">
          <div class="reset__inputs">
            <SfFormInput :label="$t('SHOP.AUTH.LABEL.EMAIL')" type="email" name="email" required />
            <SfFormInput :label="$t('SHOP.AUTH.LABEL.PASSWORD')" type="password" name="password" required />
            <SfFormInput :label="$t('SHOP.AUTH.LABEL.CONFIRM_PASSWORD')" type="password" name="password_confirmation" required />
            <SfButton primary type="submit" :loading="processing">
              {{ $t('SHOP.AUTH.ACTION.CHANGE_PASSWORD') }}
            </SfButton>
          </div>
        </FormController>
      </template>
    </SfTile>
  </main>

  <RouterView />
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .reset {
    width: 100%;
    max-width: 600px;
    margin: 100px auto;

    .reset__inputs {
      display: flex;
      flex-direction: column;
      row-gap: 1rem;
    }
  }

  @include media.query(lg) {
    .reset .tile__header {
      justify-content: center;
    }
  }
</style>
